@if (hierarchy() != null) {
  <div class="hierarchy-container">
    @for (prevLevel of previousLevels; track prevLevel.depth) {
      <div class="hierarchy-level">
        @for (node of prevLevel.nodes; track node.docId) {
          <div class="hierarchy-node">
            <document-doc-hierarchy-item [item]="node"></document-doc-hierarchy-item>
            @if (node.branchDocs?.length) {
              <div class="hierarchy-branch">
                @for (branch of node.branchDocs; track branch.docId) {
                  <div class="hierarchy-branch-row">
                    <i class="digi-out-arrow-timeline"></i>
                    <document-doc-hierarchy-item [item]="branch"></document-doc-hierarchy-item>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
      <i class="digi-out-next"></i>
    }

    <div class="hierarchy-level">
      <div class="hierarchy-node">
        <document-doc-hierarchy-item
          [item]="hierarchy()"
          [isCurrentDoc]="true"
        ></document-doc-hierarchy-item>
        @if (hierarchy()?.branchDocs?.length) {
          <div class="hierarchy-branch">
            @for (branch of hierarchy()!.branchDocs; track branch.docId) {
              <div class="hierarchy-branch-row">
                <i class="digi-out-arrow-timeline"></i>
                <document-doc-hierarchy-item [item]="branch"></document-doc-hierarchy-item>
              </div>
            }
          </div>
        }
      </div>
    </div>

    @for (nextLevel of nextLevels; track nextLevel.depth) {
      <i class="digi-out-next"></i>
      <div class="hierarchy-level">
        @for (node of nextLevel.nodes; track node.docId) {
          <div class="hierarchy-node">
            <document-doc-hierarchy-item [item]="node"></document-doc-hierarchy-item>
            @if (node.branchDocs?.length) {
              <div class="hierarchy-branch">
                @for (branch of node.branchDocs; track branch.docId) {
                  <div class="hierarchy-branch-row">
                    <i class="digi-out-arrow-timeline"></i>
                    <document-doc-hierarchy-item [item]="branch"></document-doc-hierarchy-item>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
